import type { ZodType } from 'zod';

export const safeParseAsync = async <TOutput>(
  zodSchema: ZodType<TOutput>,
  entity: unknown,
  errorPrefix: string
): Promise<TOutput> => {
  const parsed = await zodSchema.safeParseAsync(entity);
  if (parsed.success) {
    return parsed.data;
  } else {
    if (process.env['NODE_ENV'] !== 'production') {
      console.warn(
        `[ZodError/${errorPrefix}] ${JSON.stringify(parsed.error.format())}`
      );
    }
    return entity as TOutput;
  }
};
